import React from 'react';
import {useStyles} from "./ShowItemsSelectedAmount.style";
import ShowItemsSelectedAmountProperties from "./ShowItemsSelectedAmountProperties";

const ShowItemsSelectedAmount: React.FC<ShowItemsSelectedAmountProperties> = ({
                                                    amount,
                                                    elementLabel,
                                                    elementLabelPlural,
                                                    elementIsMale = true,
                                                    className = '',
                                                }) => {
    const classes = useStyles();

    if (amount === 0) {
        return <></>;
    }

    return (
        <div className={className}>
            <div className={classes.elements_count}>
                <div>{amount}</div>
                <div>
                {amount === 1 ? elementLabel : elementLabelPlural}{' '}
                {(elementIsMale ? 'seleccionado' : 'seleccionada') + (amount > 1 ? 's' : '')}
                </div>
            </div>
        </div>
    )
}
export default ShowItemsSelectedAmount;